module.exports = __webpack_public_path__ + "media/images/iconSocialX__inactive-ef41b59c4d653f60b3e110179a15410d.png";